import Swal from 'sweetalert2'

export const userKey = '_Sollicita.Portal'
export const rememberKey = '_Sollicita.Portal_remember'

export var urlSite = ''
export var urlApi = ''
export var urlApiSollicita = ''
export var _leitorPDF = ''

var urlBase = 'sollicita.com.br'
export var urlPlanos = 'https://sollicita.com.br/Planos'
export var urlOrientacoes = 'https://orientacao.' + urlBase + '/'
export var urlMural = 'https://mural.' + urlBase + '/'
export var urlFerramentas = 'https://' + urlBase + '/'
export var urlPeriodicos = 'https://periodicos.' + urlBase + '/'
export var urlSuporte = 'https://gnp.negociospublicos.net.br/np/suporte/login?';

var dev = false;
if (dev) {
    urlSite = 'https://localhost:8080'

    // local
    urlApi = 'https://localhost:44324/api/v1'
    //export const urlApi = 'http://localhost:64/api/v1'

    urlApiSollicita = 'http://localhost:82/NP/SollicitaAdmin/api'
    //export const urlApiSollicita = 'https://gnp.negociospublicos.net.br/NP/SollicitaAdmin/api'
    _leitorPDF = 'https://app.sollicita.com.br/Home/Leitor?url=';

    urlMural = 'http://localhost:8081/';
    urlFerramentas = 'http://localhost:8082/';
    urlPeriodicos = 'http://localhost:8081/';
    urlSuporte = 'http://localhost:82/np/suporte/login?';
} else {
    urlSite = 'https://portal.' + urlBase +'/'
    urlApi = 'https://api.' + urlBase +'/api/v1'
    urlApiSollicita = 'https://gnp.negociospublicos.net.br/NP/SollicitaAdmin/api'
    _leitorPDF = 'https://app.sollicita.com.br/Home/Leitor?url=';
}


export function avisoErro(e) {
    if (e && e.response && e.response.data) {
        //alert(e.response.data);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e.response.data,
        })
    } else if (typeof e === 'string') {
        //alert(e);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    } else {
        //alert('Erro');
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    }
}

export function avisoSucesso(msg) {
    Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: msg,
    })
}

export default {
    userKey,
    rememberKey,
    urlApi,
    avisoErro,
    avisoSucesso,
    urlApiSollicita,
    urlSite,
    _leitorPDF,
    urlPlanos,
    urlOrientacoes,
    urlMural,
    urlFerramentas,
    urlPeriodicos,
    urlSuporte
}